// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const updateShowSelectAll = showSelectAll => ({
    showSelectAll,
    type: actions.UPDATE_ADVANCED_CLAIM_SUMMARY_SHOW_SELECT_ALL
});



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/action-creators/show-select-all.js